export default "__VITE_ASSET__DfZ8cSCX__"